
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feature-request",
      function () {
        return require("private-next-pages/feature-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feature-request"])
      });
    }
  